import { connect } from 'react-redux'
import { sagaActions } from '../../sagas'
import { sagaActions as rootSagaActions } from 'store/sagas'
import layoutSettingsSelector from './layoutSettingsSelector'
import LayoutSettings from './LayoutSettings'

export default connect(
  layoutSettingsSelector,
  {
    fetchHomeLayout: sagaActions.fetchHomeLayout,
    requestRemoveLayout: sagaActions.requestRemoveLayout,
    requestSetLayoutAsPrivate: sagaActions.requestSetLayoutAsPrivate,
    requestSetLayoutAsPublic: sagaActions.requestSetLayoutAsPublic,
    requestDownloadLayoutTemplate: rootSagaActions.requestDownloadLayoutTemplate,
  }
)(LayoutSettings)
